import React, { useState } from 'react';
import { Drawer, List, ListItem, Badge } from '@mui/material';
import styles from './ccf-wem-left-nav.module.scss';
import {
  CcfBox,
  CcfTooltip,
  CcfWemEvaluationsIcon,
  CcfWemMyScheduleIcon,
  CcfWemRecentInteractionsIcon,
  CcfWemScheduleRequestsIcon,
  CcfWemShiftBiddingIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { CcfWemMySchedule } from '../ccf-wem-dashboard/ccf-wem-my-schedule';
import { CcfWemCcfWemScheduleRequestes } from '../ccf-wem-dashboard/ccf-wem-schedule-requests';
import { CcfWemEvaluations } from '../ccf-wem-dashboard/ccf-wem-evaluations';
import { CcfWemRecentInteraction } from '../ccf-wem-dashboard/ccf-wem-recent-interactions';
import { CcfWemShiftBidding } from '../ccf-wem-dashboard/ccf-wem-shift-bidding';
import { CcfWemCoachingSessions } from '../ccf-wem-dashboard/ccf-wem-coaching-sessions';
/* eslint-disable-next-line */
export interface CcfWemLeftNavProps {}

/**
 * Used for Application Navigation
 * @param props - ? - CcfAppNavigationProps
 * @example `<CcfAppNavigation />`
 */
export function CcfWemLeftNav(props: CcfWemLeftNavProps) {
  const [selectedMenu, setSelectedMenu] = useState('mySchedule');
  const [translate] = useTranslator();
  /**
   * Used to swtich menus
   * @param menuName - string
   * @example - setMenu(Navigation.HOME)
   */
  const setMenu = (name: string) => {
    setSelectedMenu(name);
    // setSelectedMenu((prevState) => ({ ...prevState, name, path }));
    //history.push(path);
  };

  /**
   * Function to handle drawer open close
   * @example renderIconForType()
   */
  const renderIconForTooltip = (param: string) => {
    switch (param) {
      case 'mySchedule':
        return <CcfWemMyScheduleIcon />;
      case 'ScheduleRequests':
        return <CcfWemScheduleRequestsIcon />;
      case 'Evaluations':
        return <CcfWemEvaluationsIcon />;
      case 'ShiftBidding':
        return <CcfWemShiftBiddingIcon />;
      case 'RecentInteractions':
        return <CcfWemRecentInteractionsIcon />;
      case 'CoachingSessions':
        return (
          <CcfBox style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src="./assets/Coaching.png"
              alt="Scheduled"
              style={{ width: '21px' }}
            />
          </CcfBox>
        );
      default:
        return '';
    }
  };

  /**
   * Used to render the translated tooltip for menu
   * @param title - string
   * @param listItem - menu element
   * @param navItem - string
   * @example renderToolTipMenuList(title, listItem, navItem)
   */
  const renderToolTipMenuList = (
    title: string,
    listItem: any,
    navItem?: string
  ) => {
    return (
      <div>
        <CcfTooltip
          title={
            <div
              className={styles.tooltipContainer}
              style={{
                backgroundColor:
                  selectedMenu === title ? '#ebebeb' : 'transparent',
              }}
            >
              {renderIconForTooltip(title)}
              <span className={styles.tooltipTitle}>{translate(title)}</span>
            </div>
          }
          arrow
          placement="right"
          tooltipForRTL="ccfTooltipRight0"
          styles={{
            ccfTooltipArrow: {
              color: 'white',
            },
            ccfTooltip: {
              borderRadius: '8px',
              width: '250px',
              height: 'auto',
              backgroundColor: 'white',
              boxShadow: '0px 5px 15px 0px rgb(0 0 0 / 30%)',
              padding: '8px 0px',
              color: 'grey',
            },
          }}
        >
          <div>{listItem}</div>
        </CcfTooltip>
      </div>
    );
  };

  return (
    <section
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <nav
        className={styles.sidebarContainer}
        style={{
          height: 'calc(100% - 30px)',
          backgroundColor: '#eaf1f7',
        }}
      >
        <Drawer
          variant="permanent"
          classes={{
            paper: styles.sidebar,
          }}
          anchor="left"
        >
          <List>
            <div className="homeItemToolTipWrapper">
              {renderToolTipMenuList(
                'mySchedule',
                <ListItem
                  classes={{
                    gutters: styles.sidebarItem,
                    selected: styles.sidebarItemSelected,
                  }}
                  button
                  selected={selectedMenu === 'mySchedule'}
                  onClick={() => setMenu('mySchedule')}
                >
                  <CcfWemMyScheduleIcon
                    classes={{
                      root:
                        selectedMenu === 'mySchedule'
                          ? styles.sidebarItemIconActiveColor
                          : styles.sidebarItemIconColor,
                    }}
                  />
                </ListItem>
              )}
            </div>
            <div className="assignmentItemToolTipWrapper">
              {renderToolTipMenuList(
                'ScheduleRequests',
                <ListItem
                  classes={{
                    gutters: styles.sidebarItem,
                    selected: styles.sidebarItemSelected,
                  }}
                  button
                  selected={selectedMenu === 'ScheduleRequests'}
                  onClick={() => setMenu('ScheduleRequests')}
                >
                  <Badge
                    classes={{
                      badge: styles.sidebarItemBadge,
                    }}
                  >
                    <CcfWemScheduleRequestsIcon
                      classes={{
                        root:
                          selectedMenu === 'ScheduleRequests'
                            ? styles.sidebarItemIconActiveColor
                            : styles.sidebarItemIconColor,
                      }}
                    />
                  </Badge>
                </ListItem>
              )}
            </div>
            <div className="calendarItemToolTipWrapper">
              {renderToolTipMenuList(
                'Evaluations',
                <ListItem
                  classes={{
                    gutters: styles.sidebarItem,
                  }}
                  button
                  selected={selectedMenu === 'Evaluations'}
                  onClick={() => setMenu('Evaluations')}
                >
                  <CcfWemEvaluationsIcon
                    classes={{
                      root:
                        selectedMenu === 'Evaluations'
                          ? styles.sidebarItemIconActiveColor
                          : styles.sidebarItemIconColor,
                    }}
                  />
                </ListItem>
              )}
            </div>
            <div className="directoryItemTooltipWrapper">
              {renderToolTipMenuList(
                'ShiftBidding',
                <ListItem
                  classes={{
                    gutters: styles.sidebarItem,
                  }}
                  button
                  selected={selectedMenu === 'ShiftBidding'}
                  onClick={() => setMenu('ShiftBidding')}
                >
                  <CcfWemShiftBiddingIcon
                    classes={{
                      root:
                        selectedMenu === 'Shift Bidding'
                          ? styles.sidebarItemIconActiveColor
                          : styles.sidebarItemIconColor,
                    }}
                  />
                </ListItem>
              )}
            </div>
            <div className="queueItemTooltipWrapper">
              {renderToolTipMenuList(
                'RecentInteractions',
                <ListItem
                  classes={{
                    gutters: styles.sidebarItem,
                  }}
                  button
                  selected={selectedMenu === 'RecentInteractions'}
                  onClick={() => setMenu('RecentInteractions')}
                >
                  <CcfWemRecentInteractionsIcon
                    classes={{
                      root:
                        selectedMenu === 'RecentInteractions'
                          ? styles.sidebarItemIconActiveColor
                          : styles.sidebarItemIconColor,
                    }}
                  />
                </ListItem>
              )}
            </div>

            <div className="wemItemTooltipWrapper">
              {renderToolTipMenuList(
                'CoachingSessions',
                <ListItem
                  classes={{
                    gutters: styles.sidebarItem,
                  }}
                  button
                  selected={selectedMenu === 'CoachingSessions'}
                  onClick={() => setMenu('CoachingSessions')}
                >
                  <CcfBox
                    classes={{
                      root:
                        selectedMenu === 'CoachingSessions'
                          ? styles.sidebarItemIconActiveColor
                          : styles.sidebarItemIconColor,
                    }}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <img src="./assets/Coaching.png" alt="Scheduled" />
                  </CcfBox>
                </ListItem>
              )}
            </div>
          </List>
        </Drawer>

        {/* <div> */}
        {selectedMenu === 'mySchedule' ? (
          <CcfWemMySchedule />
        ) : selectedMenu === 'ScheduleRequests' ? (
          <CcfWemCcfWemScheduleRequestes />
        ) : selectedMenu === 'Evaluations' ? (
          <CcfWemEvaluations />
        ) : selectedMenu === 'ShiftBidding' ? (
          <CcfWemShiftBidding />
        ) : selectedMenu === 'RecentInteractions' ? (
          <CcfWemRecentInteraction />
        ) : (
          <CcfWemCoachingSessions />
        )}
        {/* </div> */}
      </nav>
    </section>
  );
}

export default CcfWemLeftNav;
